import { render, staticRenderFns } from "./SwipeModalDishes.vue?vue&type=template&id=aeb455f4&"
import script from "./SwipeModalDishes.vue?vue&type=script&lang=js&"
export * from "./SwipeModalDishes.vue?vue&type=script&lang=js&"
import style0 from "./SwipeModalDishes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports